import { render, staticRenderFns } from "./CustomBackgroundWrapper.vue?vue&type=template&id=5ccb737e"
import script from "./CustomBackgroundWrapper.vue?vue&type=script&lang=js"
export * from "./CustomBackgroundWrapper.vue?vue&type=script&lang=js"
import style0 from "./CustomBackgroundWrapper.vue?vue&type=style&index=0&id=5ccb737e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports